var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.986,
    height: 91.989,
    viewBox: "0 0 91.986 91.989",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.007)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.62 26.23)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M151.139,209.38l-4.505-13.295a1.8,1.8,0,0,0-1.7-1.22h-.261V168.812a22.817,22.817,0,1,0-45.634,0v26.053h-.261a1.8,1.8,0,0,0-1.7,1.22l-4.5,13.295a1.8,1.8,0,0,0,1.7,2.373h55.167a1.8,1.8,0,0,0,1.7-2.373ZM102.63,168.812a19.224,19.224,0,1,1,38.447,0v26.053H102.63ZM96.776,208.16l3.287-9.7h43.58l3.288,9.7Z",
    transform: "translate(-92.474 -145.995)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.203)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M247.8,0A1.8,1.8,0,0,0,246,1.8v10.78a1.8,1.8,0,1,0,3.593,0V1.8A1.8,1.8,0,0,0,247.8,0Z",
    transform: "translate(-246)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.203 17.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M249.067,99.489a1.8,1.8,0,1,0,.527,1.272A1.808,1.808,0,0,0,249.067,99.489Z",
    transform: "translate(-246 -98.964)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.118 48.089)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.633,267.66h-8.25a1.8,1.8,0,0,0,0,3.593h8.25a1.8,1.8,0,1,0,0-3.593Z",
    transform: "translate(-39.587 -267.66)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.007 48.089)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.074,268.186a1.8,1.8,0,0,0-2.54,0,1.8,1.8,0,0,0,1.27,3.067,1.8,1.8,0,0,0,1.27-3.067Z",
    transform: "translate(-0.007 -267.66)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.011 9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M161.77,57.081,159.334,51.2a1.8,1.8,0,0,0-3.32,1.375l2.435,5.879a1.8,1.8,0,0,0,3.32-1.375Z",
    transform: "translate(-155.877 -50.093)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.114 31.898)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.794,180.112l-5.879-2.435A1.8,1.8,0,0,0,29.54,181l5.879,2.435a1.8,1.8,0,0,0,1.375-3.32Z",
    transform: "translate(-28.43 -177.54)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.787 48.089)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M420.708,267.66h-8.25a1.8,1.8,0,1,0,0,3.593h8.25a1.8,1.8,0,1,0,0-3.593Z",
    transform: "translate(-410.662 -267.66)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.4 48.089)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M495.06,268.186a1.8,1.8,0,1,0,.527,1.27A1.809,1.809,0,0,0,495.06,268.186Z",
    transform: "translate(-491.993 -267.66)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(69.621 13.831)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M399.381,77.507a1.8,1.8,0,0,0-2.541,0L388,86.347a1.8,1.8,0,0,0,2.541,2.541l8.84-8.84A1.8,1.8,0,0,0,399.381,77.507Z",
    transform: "translate(-387.473 -76.981)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.945 13.831)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M67.229,86.349l-8.84-8.84a1.8,1.8,0,0,0-2.541,2.541l8.84,8.84a1.8,1.8,0,0,0,2.541-2.541Z",
    transform: "translate(-55.321 -76.983)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.959 9)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M327.481,50.23a1.8,1.8,0,0,0-2.348.972L322.7,57.082a1.8,1.8,0,1,0,3.32,1.375l2.435-5.879A1.8,1.8,0,0,0,327.481,50.23Z",
    transform: "translate(-322.561 -50.094)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.413 31.897)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M440.178,178.648a1.8,1.8,0,0,0-2.348-.972l-5.879,2.435a1.8,1.8,0,1,0,1.375,3.32L439.206,181A1.8,1.8,0,0,0,440.178,178.648Z",
    transform: "translate(-430.842 -177.539)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.61 37.551)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M231.391,209.008A5.4,5.4,0,0,0,226,214.4v8.624a5.39,5.39,0,0,0,10.78,0V214.4A5.4,5.4,0,0,0,231.391,209.008Zm1.8,14.014a1.8,1.8,0,0,1-3.593,0V214.4a1.8,1.8,0,0,1,3.593,0Z",
    transform: "translate(-226.001 -209.008)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.61 60.548)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M231.391,337.005a5.39,5.39,0,1,0,5.39,5.39A5.4,5.4,0,0,0,231.391,337.005Zm0,7.186a1.8,1.8,0,1,1,1.8-1.8A1.8,1.8,0,0,1,231.391,344.191Z",
    transform: "translate(-226.001 -337.005)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.bd742a9c7fe0fe4ae076d8deaf917ab1.svg";
export { ForwardRef as ReactComponent };